import { atom } from 'jotai'
import { MEMBERSHIP_MODAL_STEPS } from 'src/modules/Modals/constants'

export const membershipModalAtom = atom<{
  step: typeof MEMBERSHIP_MODAL_STEPS[keyof typeof MEMBERSHIP_MODAL_STEPS]
  isOpen: boolean
  isRejoin: boolean
  successMessage?: string
}>({
  step: MEMBERSHIP_MODAL_STEPS.introduction,
  isOpen: false,
  isRejoin: false,
  successMessage: ''
})
